import React, { memo } from 'react';
import { convertRStoAmount } from '../../../pages/cluster-management/helper.cm';
import {
    currencyFormatWithoutDecimal,
    formatCurrencyV1,
} from '../../../utils/appHelper';

const ListSubItem = memo(({ item, ...props }: any) => {
    return (
        <React.Fragment key={props?.key}>
            {!!item?.divider && (
                <div
                    style={{
                        borderTop: '1px dashed rgba(0, 0, 0, 0.20)',
                        margin: '8px 0',
                        backgroundImage:
                            'linear-gradient(to right, rgba(0, 0, 0, 0.20) 50%, transparent 50%)',
                        backgroundSize: '10px 1px',
                        backgroundRepeat: 'repeat-x',
                        height: '1px',
                    }}
                />
            )}
            <div
                {...props}
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    width: '100%',
                    margin: '8px 0',
                    pointerEvents: 'none',
                    ...props.style,
                }}
            >
                <div style={{ flex: 1 }}>
                    <span
                        style={{
                            flex: 1,
                            marginRight: '8px',
                            fontWeight: item?.bold ? 'bold' : 'normal',
                            fontSize: '12px',
                            color: '#000',
                        }}
                    >
                        {item?.label}
                    </span>
                </div>
                <div>
                    <span
                        style={{
                            fontWeight: 'bold',
                            fontSize: '12px',
                            textAlign: 'right',
                            color: '#000',
                        }}
                    >
                        {/* {item?.amount} */}
                        {formatCurrencyV1(
                            convertRStoAmount(`${item?.amount ?? 0}`),
                            currencyFormatWithoutDecimal,
                        )}
                    </span>
                </div>
            </div>
        </React.Fragment>
    );
});

export default ListSubItem;
